import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import styled from "styled-components";
import users from "../../../apiConfigs/users";
import { ReactComponent as Seperate } from "../../../assets/seperator.svg";
import { useRoot } from "../../../context/RootProvider";
import Button from "../../../designComponents/Button";
import DeleteModal from "../../../designComponents/DeleteModal";
import Loading from "../../../designComponents/Loading";
import {
  renderRole,
  renderstatus,
} from "../../../designComponents/Table/renderMethods";
import Typography from "../../../designComponents/Typography";
import requestAPI from "../../../utils/requestAPI";
import {
  ActiveNavText,
  Navigation,
  NavLink,
  NavText,
  Title,
  Wrapper,
} from "../../Properties/Details/styles";
import { UserDetailsWrapperStyled } from "../../Users/Details/style";

type AdminDetailsType = {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  role: string;
  createdAt: string;
  updatedAt: string;
};
const Card = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  border: 1px solid #f1effb;
  gap: 20px;
  border-radius: 10px;
  padding: 20px;
  margin: 20px;
  font-family: Arial, sans-serif;
`;

const AdminDetails = () => {
  const { adminId } = useParams();
  const { auth } = useRoot();
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [adminDetail, setAdminDetail] = useState<AdminDetailsType>();
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [blockModal, setBlockModal] = useState(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const getSingleAdmin = async (id: string) => {
    setIsLoading(true);
    try {
      const response = await requestAPI(users.getSingleAdmin(id));
      setAdminDetail(response);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handleDeleteAdmin = async (id: string) => {
    setLoading(true);
    try {
      await requestAPI(users.deleteAdmin(id));
      setDeleteModalOpen(false);
      toast.success("admin deleted successfully");
      navigate("/admin");
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (adminId) {
      getSingleAdmin(adminId);
    }
  }, [adminId]);

  return (
    <UserDetailsWrapperStyled>
      {isLoading ? (
        <Loading />
      ) : (
        <Wrapper>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <Title style={{ paddingBottom: 14 }}>Admin Details</Title>
              <Navigation
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <NavLink onClick={() => navigate(-1)}>
                  <NavText>Table</NavText>
                </NavLink>
                <Seperate fill="#7E7E7E"></Seperate>
                <ActiveNavText>Admin Details</ActiveNavText>
              </Navigation>
            </div>
            <div style={{ display: "flex", gap: 40 }}>
              {auth?.role === "ADMIN" && (
                <Button
                  style={{
                    border: "1px solid #D8D8D8",
                    color: "#7E7E7E",
                    borderRadius: 6,
                    backgroundColor: "transparent",
                  }}
                  onClick={() => {
                    setDeleteModalOpen(true);
                  }}
                >
                  Delete User
                </Button>
              )}
              <Button
                style={{ backgroundColor: "#725ED4", borderRadius: 6 }}
                onClick={() => {
                  navigate(`/editUser/${adminDetail?._id}`);
                }}
              >
                Edit User
              </Button>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              flex: 1,
              gap: 20,
            }}
          >
            <Card style={{ margin: 0 }}>
              <Typography
                size={"h4"}
                fontWeight="semibold"
                style={{ color: "#242B50" }}
              >
                Information Detail
              </Typography>
              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 30,
                  }}
                >
                  <Typography
                    size={"h5"}
                    fontWeight="normal"
                    style={{ color: "#3F3F3F" }}
                  >
                    Full Name
                  </Typography>
                  <Typography style={{ color: "#5F5F5F" }}>
                    {adminDetail?.firstName + " " + adminDetail?.lastName}
                  </Typography>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 30,
                  }}
                >
                  <Typography
                    size={"h5"}
                    fontWeight="normal"
                    style={{ color: "#3F3F3F" }}
                  >
                    User ID
                  </Typography>
                  <Typography style={{ color: "#5F5F5F" }}>
                    #{adminDetail?._id}
                  </Typography>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 30,
                  }}
                >
                  <Typography
                    size={"h5"}
                    fontWeight="normal"
                    style={{ color: "#3F3F3F" }}
                  >
                    Status Badge
                  </Typography>
                  {renderstatus("ACTIVE")}
                </div>
              </div>
            </Card>

            <Card style={{ margin: 0 }}>
              <Typography
                size={"h4"}
                fontWeight="semibold"
                style={{ color: "#242B50" }}
              >
                User Detail
              </Typography>
              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 30,
                  }}
                >
                  <Typography
                    size={"h5"}
                    fontWeight="normal"
                    style={{ color: "#3F3F3F" }}
                  >
                    Full Name
                  </Typography>
                  <Typography style={{ color: "#5F5F5F" }}>
                    {adminDetail?.firstName + " " + adminDetail?.lastName}
                  </Typography>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 30,
                  }}
                >
                  <Typography
                    size={"h5"}
                    fontWeight="normal"
                    style={{ color: "#3F3F3F" }}
                  >
                    Email
                  </Typography>
                  <Typography style={{ color: "#5F5F5F" }}>
                    {adminDetail?.email}
                  </Typography>
                </div>

                {/* Role */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 30,
                  }}
                >
                  <Typography
                    size={"h5"}
                    fontWeight="normal"
                    style={{ color: "#3F3F3F" }}
                  >
                    Role
                  </Typography>
                  {renderRole(adminDetail?.role ?? "null")}
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 30,
                  }}
                >
                  <Typography
                    size={"h5"}
                    fontWeight="normal"
                    style={{ color: "#3F3F3F" }}
                  >
                    Status
                  </Typography>
                  {renderstatus("ACTIVE")}
                </div>
              </div>
            </Card>
          </div>

          <DeleteModal
            title="Are you sure want to delete this admin?"
            isOpen={isDeleteModalOpen}
            onClose={() => setDeleteModalOpen(false)}
            onDelete={() => adminId && handleDeleteAdmin(adminId)}
            itemName={`${adminDetail?.firstName} ${adminDetail?.lastName}`}
            loading={loading}
          />
        </Wrapper>
      )}
    </UserDetailsWrapperStyled>
  );
};

export default AdminDetails;
